import classNames from 'classnames';
import * as React from 'react';

import styles from './style.module.css';

interface Props extends React.HTMLAttributes<HTMLDivElement> {}

const TableContent = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <div
      ref={ref}
      {...rest}
      className={classNames(styles.tableContent, className)}
    />
  );
});

TableContent.displayName = 'TableContent';

export default TableContent;
